import React, { useState, useEffect } from 'react'
import { ImportsColumn } from "./imports_column"

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"

const columnLetter = index => {
  const letter = ALPHABET[index % ALPHABET.length]
  return index < ALPHABET.length ? letter : columnLetter(Math.floor(index / ALPHABET.length) - 1) + letter
}

const ImportsEdit = props  => {
  const samples = JSON.parse(props.samples)
  const [columns, setColumns] = useState(props.columns)
  const [errors,  setErrors]  = useState([])

  const reset = e => {
    e.preventDefault()
    setColumns({})
  }

  useEffect(() => {
    const errors     = []
    const table      = props.table
    const values     = Object.values(columns).filter(column => column)
    const required   = Object.keys(table).filter(column => table[column].required)
    const duplicates = (new Set(values)).size !== values.length
    if (duplicates) { errors.push(I18n.t("import.errors.columns_repeated")) }
    if (!props.editing) {
      const missing = required.filter(r => !values.includes(r)).map(m => table[m].name).join(", ")
      if (missing.length > 0) { errors.push(I18n.t("import.errors.columns_missing", { missing })) }
    }
    setErrors(errors)
  }, [columns])
  return(
    <>
      { samples.map(([column, values], index) =>
        <ImportsColumn
          key        = {column}
          letter     = {columnLetter(index)}
          column     = {column}
          samples    = {values}
          columns    = {columns}
          setColumns = {setColumns}
          table      = {props.table}
          type       = {props.type}
          editing    = {props.editing}
        />
      )}
      {errors.length > 0 &&
        <div className="imports-errors">
          { errors.map(error => <p key={error}>{error}</p>) }
        </div>
      }

      <div className="invoice-float-buttons">
        <a className="btn btn-outline-default" href="/imports">
          { I18n.t("button.cancel")}
        </a>

        <button
          name      = "button"
          className = "btn btn-outline-default"
          onClick   = {reset}
        >
          { I18n.t("workorders.reset_filter") }
        </button>

        <button
          name      = "button"
          type      = "submit"
          className = "btn btn-primary"
          disabled  = { errors.length > 0 }
        >
          { I18n.t("import.test") }
        </button>
      </div>
    </>
  )
}

export default ImportsEdit

